import React from 'react';
import PropTypes from 'prop-types';
import { MdCheck } from 'react-icons/md';
import {
  SectionLabel,
  SectionPrompt,
  MutedText,
  ChipsPanel,
  SelectableChip,
  CheckboxHolder,
  CheckboxBox,
  ChipsBox
} from './styled';
import { entitlementLabel } from './entitlements';

// "Your purchased add-on(s)" block. Selecting a checkbox only updates local
// dashboard state — nothing is sent to the API here. Selecting the first add-on
// is also what moves the dashboard into add-ons mode, which is why selection is
// owned by the parent.
const AddOnSelector = ({ addOns, selectedIds, onToggle, locked }) => (
  <div>


    <ChipsBox >
      <SectionLabel>Extras you still need to assign</SectionLabel>

      <SectionPrompt style={{ marginTop: 10 }}>
        {!addOns.length ? 'No add-ons to assign.' : 'You also purchased these add-on(s). Select one or more, then add them to a book below.'}
      </SectionPrompt>
      {addOns.length > 0 && <ChipsPanel role="group" style={{ marginTop: 10 }} aria-label="Purchased add-ons">
        {addOns.map(addOn => {
          const checked = selectedIds.includes(addOn.id);
          return (
            <SelectableChip
              key={addOn.id}
              type="button"
              role="checkbox"
              aria-checked={checked}
              disabled={locked}
              onClick={() => onToggle(addOn.id)}
            >
              <CheckboxHolder>
                <CheckboxBox checked={checked}>
                  {checked && <MdCheck size={16} />}
                </CheckboxBox>
              </CheckboxHolder>
              {entitlementLabel(addOn)}
            </SelectableChip>
          );
        })}
      </ChipsPanel>}
    </ChipsBox>

  </div>
);

AddOnSelector.propTypes = {
  addOns: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      description: PropTypes.string,
      bundleName: PropTypes.string,
    })
  ),
  selectedIds: PropTypes.arrayOf(PropTypes.string),
  onToggle: PropTypes.func.isRequired,
  // True once a batch has been confirmed and is being persisted, so the customer
  // can't retoggle mid-flight ("add ons locked in after confirmed").
  locked: PropTypes.bool,
};

AddOnSelector.defaultProps = {
  addOns: [],
  selectedIds: [],
  locked: false,
};

export default AddOnSelector;
